import { Component, Input, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-group-options',
  templateUrl: './group-options.component.html',
  styleUrls: ['./group-options.component.scss'],
})
export class GroupOptionsComponent implements OnInit {
  @Input() set savedForm(value) {
    if (value) {
      this.groupOptions = value.grupoOptions;
    }
  }
  public groupOptions: any[] = [];

  constructor(private httpSv: HttpService, private uiSv: UiServices) {}

  ngOnInit() {}

  async doReorder(ev: any) {
    this.groupOptions = ev.detail.complete(this.groupOptions);
    this.groupOptions.forEach((element, index) => {
      element.orden = index + 1;
    });

    await this.httpSv.itemAction(
      {
        data: JSON.stringify(
          this.groupOptions.map(({ id, orden }) => ({
            id,
            orden,
          }))
        ),
      },
      'multiOptions',
      'updateMany'
    );

    this.uiSv.showToast('Orden actualizado');
  }
}
